import React, { Component } from 'react';
import classnames from 'classnames';
import Button from '@tencent/dui/lib/components/Button';
import Style from './index.less';
import i18n from '@i18next/i18n';

// PPT直播（live）的用户引导框，没有什么功能就是用户教育。


interface LiveGuideDialogProps {
    darkMode?: boolean;
    handleCloseLiveGuideDialog?: () => void;
    handleOpenDocLive?: () => void;
}

// @observer
class LiveGuideDialog extends Component<LiveGuideDialogProps> {
    public constructor(props) {
        super(props);
    }

    public render() {
        const textColor = this.props.darkMode ? '#FFF' : '#333333';
        return (
            <div className={classnames([Style['dialog-wrapper'], Style.bubble, Style.top, (this.props.darkMode ? Style['bubble-dark'] : null)])}>
                <button aria-label="Close" className={Style['modal-close']} onClick={this.props.handleCloseLiveGuideDialog}><span className={Style['modal-close-x']}></span></button>
                <div className={Style['modal-content']}>
                    <h1 style={{ color: textColor }}>{i18n.t('欢迎使用远程演示')}</h1>
                    <p className={`${Style['modal-p']} ${this.props.darkMode ? Style['dark-text'] : null}`}>{i18n.t('手机电脑同步观看，语音讨论更加高效')}
                    </p>
                    {
                        this.props.darkMode ? null : <div className={`${Style['icon-guide-2x']}`}></div>
                    }
                    <Button className={Style['sm-button']} type="primary" size="large" onClick={this.props.handleOpenDocLive}>{i18n.t('邀请好友')}</Button>
                </div>
            </div>
        );
    }
}

export default LiveGuideDialog;
